<template>

  <div class="col-12 mx-auto">
    <router-link :to="{name: 'MeetingDate'}" class="text-dark text-decoration-none">
      <div class="bg-white d-flex flex-column gap-2 rounded-12px border border-2">
        <div class="d-flex flex-column ">
          <div class="d-flex gap-2 align-items-center justify-content-between w-100 mb-auto p-3 pb-lg-3 pb-0">
            <div class="bg-success status-circle mb-lg-4 mb-0" style="width:14px; height:14px;"></div>
            <div class="d-flex flex-column gap-2 fw-bold fs-14px">
              <div>{{ meeting.title }}</div>
              <!-- Desktop Only -->
              <span class="fs-12px text-secondary fw-normal d-lg-block d-none">{{ meeting.subtitle }}</span>
              <!-- End desktop -->
            </div>
            <!-- Desktop Only -->
            <div class="d-lg-flex d-none flex-column gap-2 fw-bold mx-auto fs-14px">
              <div class="fs-14px text-secondary fw-normal">المنصة</div>
              <img src="@/assets/images/zm-02_2x.png" width="44" alt="" />
            </div>
            <div class="d-lg-flex d-none flex-column gap-2 fw-bold mx-auto fs-14px">
              <div class="fs-14px text-secondary fw-normal">المدة</div>
              <div class="fw-bold fs-6">{{ meeting.duration }}</div>
            </div>
            <div class="d-lg-flex d-none flex-column gap-2 fw-bold mx-auto fs-14px">
              <div class="fs-14px text-secondary fw-normal">السعر</div>
              <div class="fw-bold fs-6">{{ meeting.price }}</div>
            </div>
            <!-- End desktop Only -->
            <img src="@/assets/images/chevron-right.svg" alt="" class="ms-lg-0 ms-auto" />
          </div>
          <!-- Mobile Only -->
          <div class="d-lg-none d-flex gap-3 align-items-center w-100 px-3">
            <div class="px-1"></div>
            <span class="fs-12px text-secondary fw-normal">{{ meeting.subtitle }}</span>
          </div>
        </div>
        <div class="d-lg-none d-block border-top border-2"></div>
        <!-- Mobile Only -->
        <div class="d-lg-none d-flex justify-content-between py-2">
          <div class="d-flex flex-column gap-1 px-3">
            <div class="d-flex align-items-center gap-2">
              <img src="@/assets/images/link2.svg" width="12" alt="" />
              <span class="fs-12px text-secondary">المنصة</span>
            </div>
            <div class="d-flex gap-2 mt-1">
              <div></div>
              <img src="@/assets/images/zm-02_2x.png" width="44" alt="" />
            </div>
          </div>
          <div class="d-flex flex-column section-seperator gap-1 px-3">
            <div class="d-flex align-items-center gap-2">
              <img src="@/assets/images/clock.svg" width="12" alt="" />
              <span class="fs-12px text-secondary">المدة</span>
            </div>
            <div class="d-flex gap-2">
              <div></div>
              <div class="fw-bold fs-6">{{ meeting.duration }}</div>
            </div>
          </div>
          <div class="d-flex flex-column section-seperator gap-1 px-3">
            <div class="d-flex align-items-center gap-2">
              <img src="@/assets/images/dollar.svg" width="12" alt="" />
              <span class="fs-12px text-secondary">السعر</span>
            </div>
            <div class="d-flex gap-2">
              <div></div>
              <div class="fw-bold fs-6">{{ meeting.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['meeting'],
}
</script>

<style>
</style>